import React, { useState } from "react";
import "./FAQ.css";
import Accordion from 'react-bootstrap/Accordion';

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState("Program");
  const categories = [
    "Program",
    "Teaching",
    "Mentors",
    "Placement Support",
    "Tuition fee",
  ];

  const faqData = {
    Program: [
      {
        question: "What makes this program different from other training courses?",
        answer:
          "Our program focuses on practical learning, real-world projects, industry tools, and career guidance to make you job-ready from day one.",
      },
      {
        question: "Is this program suitable for beginners?",
        answer:
          "Yes. The curriculum starts from the fundamentals and gradually progresses to advanced concepts, making it ideal for freshers and career switchers.",
      },
      {
        question: "Will I work on real-world projects?",
        answer:
          "Absolutely. You will gain hands-on experience through industry-based projects that help you build a strong portfolio.",
      },
      {
        question: "What skills will I gain after completing the program?",
        answer: "You will learn technical skills, problem-solving techniques, project execution, and industry best practices required by employers.",
      },
      {
        question: "Can working professionals join this program?",
        answer:
          "Yes. Our flexible learning approach is designed for students, fresh graduates, and working professionals.",
      },
      {
        question: "How long does it take to complete the program?",
        answer:
          "Program duration varies based on the course, but all programs are structured to provide comprehensive practical training within a reasonable timeframe.",
      },
      {
        question: "What career opportunities can I expect after completion?",
        answer:
          "Depending on the program, you can pursue roles such as Data Analyst, Data Engineer, Business Analyst, Software Developer, and more.",
      },
    ],

    Teaching: [
      {
        question: "How are the classes conducted?",
        answer:
          "Classes are conducted through live interactive ONLINE and OFFLINE sessions with practical demonstrations and hands-on exercises.",
      },
      {
        question: "Will I get practical training or only theory?",
        answer:
          "Our training is heavily focused on practical implementation, real-time projects, and case studies with hands-on practice.",
      },
      {
        question: "Can I access recorded sessions?",
        answer:
          "Yes. Session recordings are provided on our ANDROID Application available on Google play Store names :- PST IT SOLUTION , so you can revise concepts anytime.",
      },
      {
        question: "How do trainers help students understand difficult topics?",
        answer:
          "Trainers explain concepts using real-world examples, practical scenarios, and one-on-one doubt-solving sessions.",
      },
      {
        question: "Are assignments included in the training?",
        answer:
          "Yes. Regular assignments and mock interview with assessments help reinforce learning and track progress.",
      },
      {
        question: "What if I miss a class?",
        answer:
          "You can access recordings and connect with trainers to clear any doubts at any time.",
      },
      {
        question: "How much hands-on practice will I get?",
        answer:
          "You will spend a significant portion of the program working on exercises, projects, and real industry use cases.",
      },
      
    ],

    Mentors: [
      {
        question: "Who will be teaching and mentoring me?",
        answer:
          "You will learn from experienced industry professionals with practical knowledge of real-world projects.",
      },
      {
        question: "Can I interact directly with mentors?",
        answer:
          "Yes. Students have direct access to mentors during sessions and doubt-clearing discussions.",
      },
      {
        question: "Will mentors help with career guidance?",
        answer:
          "Absolutely. Mentors provide guidance on career paths, industry expectations, profile building and skill development.",
      },
      {
        question: "How experienced are the mentors?",
        answer:
          "Our mentors have extensive industry experience and have worked on real-world business and technology projects with many big MNC clients.",
      },
      {
        question: "Can mentors help me build projects?",
        answer:
          "Yes. Mentors guide you through project development and help you apply concepts effectively.",
      },
      {
        question: "Will I receive interview guidance from mentors?",
        answer:
          "Yes. Mentors share interview strategies, commonly asked questions, and practical tips for success.",
      },
      {
        question: "How do mentors support my learning journey?",
        answer:
          "They provide personalized feedback, technical guidance, career advice, and continuous motivation throughout the program.",
      },
     
    ],

    "Placement Support": [
      {
        question: "Do you provide placement assistance?",
        answer:
          "Yes. We offer dedicated placement support to help students prepare for job opportunities untill they placed somewhere.",
      },
      {
        question: "What kind of placement support will I receive?",
        answer:
          "Resume building, mock interviews, career counseling, profile optimization, and job referral assistance.",
      },
      {
        question: "Will you help me prepare for interviews?",
        answer:
          "Yes. We conduct mock interviews and provide guidance on technical and HR interview preparation.",
      },
      {
        question: " Can freshers get placement support?",
        answer:
          "Absolutely. Our placement assistance is designed for both freshers and experienced professionals.",
      },
      {
        question: "Do you help with resume creation?",
        answer:
          "Yes. We help you create a professional, industry-standard resume that highlights your strengths.",
      },
      {
        question: "How soon can I start applying for jobs?",
        answer:
          "You can begin applying once you have acquired the required skills and completed key projects.",
      },
      {
        question: "How does placement support improve my chances of getting hired?",
        answer:
          "By improving your technical skills, interview confidence, project portfolio, and professional profile.",
      },
    ],

    "Tuition fee": [
      {
        question: "Is the course fee affordable for students and freshers?",
        answer: "Yes. We offer quality industry-focused training at a competitive and affordable fee structure.",
      },
      {
        question: "Do you provide instalments payment options?",
        answer: "Yes. Easy instalments options are available to make learning accessible to everyone.",
      },
      {
        question: "Are there any hidden charges?",
        answer: "No. We maintain complete transparency regarding course fees and payment details.",
      },
      {
        question: "Is the training worth the investment?",
        answer: "Absolutely. The practical skills, projects, mentorship, and placement support provide excellent career value.",
      },
      {
        question: "Can I get a fee consultation before enrolling?",
        answer: "Yes. Our counsellors can explain the fee structure and available payment options in detail.",
      },
      {
        question: "Do you offer discounts or scholarship opportunities?",
        answer: "Special offers, discounts, and scholarship programs may be available for eligible candidates.",
      },
      {
        question: "Why should I invest in this program?",
        answer: "Investing in professional skill development can significantly improve your career opportunities, earning potential, and job readiness.",
      },
      
    ],
  };

  return (
    <section className="FAQ">
      <div className="container">
        <div className="FAQ_header">
          <h5>
            Frequently Asked <span className="title_span">Questions</span>{" "}
          </h5>
          <span>
            <img
              src="/assets/images/home/FAQ/title-img.png"
              alt="title-img"
              className="title_img"
            />
          </span>
        </div>

        <div className="FAQ_div">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-3 col-sm-4">
              <div className="faq_categories">
                {categories.map((item, index) => (
                  <div
                    key={index}
                    className={`faq_category_item ${
                      activeCategory === item ? "active" : ""
                    }`}
                    onClick={() => setActiveCategory(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-8 col-md-9 col-sm-8">
              <div className="faq_content ">
                <div className="faq_content_header">{activeCategory}</div>

                <Accordion >
                  {faqData[activeCategory].map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
